<template>
    <Head :title="t('peopleDirectory.createTeam.title')" />
    <BaseLayout gap="lg" class="fs-mask">
        <TeamCreateForm
            :creator="creator"
            :search-url="search_url"
            :create-url="create_url"
            :recommendations-url="recommendations_url"
            :back-url="back_url"
            @created="router.visit($event.url)" />
    </BaseLayout>
</template>

<script lang="ts">
import LeftSidebarLayout from "~vue/layouts/LeftSidebarLayout.vue";
export default { layout: LeftSidebarLayout };
</script>

<script setup lang="ts">
import { Head, router } from "@inertiajs/vue3";
import type { TeamCreatePage } from "~vue/api/generated/team-perspective/types.gen";
import BaseLayout from "~vue/components/BaseLayout.vue";
import TeamCreateForm from "~vue/Connections/TeamCreateForm.vue";
import { useI18n } from "vue-i18n";

defineProps<TeamCreatePage>();
const { t } = useI18n();
</script>
